import React from "react";

function Questionsvg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            stroke="#2c3e50"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            className="icon icon-tabler icon-tabler-question-mark"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z"></path>
            <path d="M8 8a3.5 3 0 013.5-3h1A3.5 3 0 0116 8a3 3 0 01-2 3 3 4 0 00-2 4"></path>
            <path d="M12 19L12 19.01"></path>
        </svg>
    );
}

export default Questionsvg;